
  import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
  import { Field, DropdownField } from '@samc/centricity-core';
  import { SalesPersonSource } from '@/Sources';

  @Component({
    name: 'sales-person-dropdown-field',
    components: { Field, DropdownField }
  })
  export default class SalesPersonDropdownField extends Vue {
    @Prop() public value!: number;
    @Prop({ default: 'Salesperson' }) public label!: string;
    @Prop({ default: '' }) public errorText!: string;
    @Prop({ type: Boolean, default: false }) public disabled!: boolean;
    @Prop({ type: Boolean, default: false }) public autoAssign!: boolean;
    @Prop() public placeholder!: string;
    public searchWith: string = '';

    public source: SalesPersonSource = new SalesPersonSource();

    public get val(): number { return this.value; }
    public set val(value: number) {
      this.$emit('input', value);
    }
  }
